import { useApp } from '../context.js';
import RestaurantCard from './RestaurantCard.jsx';

export default function RestaurantList() {
    const { activeRestaurantCount, searchQuery, setSearchQuery, showUnratedOnly, sortedRestaurants } = useApp();
    const filtering = !!searchQuery.trim() || activeRestaurantCount > 0;
    return (
        <div className="space-y-3">
            {sortedRestaurants.map((restaurant, index) => (
                <RestaurantCard key={restaurant.id} restaurant={restaurant} index={index} />
            ))}

            {sortedRestaurants.length === 0 && !showUnratedOnly && filtering && (
                <div className="text-center py-16 text-gray-400">
                    <p className="text-lg font-medium">{searchQuery.trim() ? `No matches for “${searchQuery.trim()}”` : 'Nothing matches these filters'}</p>
                    {searchQuery.trim() && (
                        <button onClick={() => setSearchQuery('')} className="text-sm mt-3 underline underline-offset-2 text-gray-500">Clear search</button>
                    )}
                </div>
            )}
            {sortedRestaurants.length === 0 && !showUnratedOnly && !filtering && (
                <div className="text-center py-16 text-gray-400">
                    <p className="text-lg font-medium">No restaurants yet!</p>
                    <p className="text-sm mt-2">Add your first place 🍴</p>
                </div>
            )}
            {sortedRestaurants.length === 0 && showUnratedOnly && (
                <div className="text-center py-16 text-gray-400">
                    <p className="text-lg font-medium">No unrated restaurants</p>
                    <p className="text-sm mt-2">All your places have ratings! ⭐</p>
                </div>
            )}
        </div>
    );
}
